import React from "react";
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { medecinComp, medecinuom } from '../utils/datalist';
import { Modal, Button, Form } from "react-bootstrap";

const FirstMovingItemsCom=()=>{

    const [itemData,setItemData]=useState([]);
    const [noResults, setNoResults] = useState(false);

    const [startDate, setStartDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    const [endDate, setEndDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    const handleSubmit=async(e)=>{
    e.preventDefault();

    if (!startDate || !endDate) {
        alert('Dates required.');
        return;
    }   

    try {
      const res = await axios.get(configData.SERVER_URL+`/issueByDateRange/${startDate}/${endDate}/${localStorage.getItem('branchID')}`);
      setItemData(res.data);      

      if (res.data.length === 0) {
        setNoResults(true);
      } else {
        setNoResults(false);
      }
    } catch (error) {
      console.error('Search error:', error);
    }   
    }

    return(
        <>    
  
        <div className="card well bg-info "> 
                    <div className="card-header">First Moving Items</div>
                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        <div className="col-lg-3">
                                            <label>Date From</label>
                                            <input type="date" className="form-control" name="sDate" id="sDate" value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}></input>
                                        </div>

                        <div className="col-lg-3">
                                            <label>Date To</label>
                                            <input type="date" className="form-control" name="eDate" id="eDate" value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}></input>
                                        </div>

                        <div className="col-lg-2">
                                            <br></br>
                                            <button type="button" class="btn btn-info">
                                                <span class="glyphicon glyphicon-search" onClick={(e)=>{handleSubmit(e)}}><Icon.Search/></span>
                                            </button>
                                        </div>
                    </div>

                    {noResults && <p class="text-center" >No results found.</p>}

                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        <div className="table-responsive-sm table-responsive-md table-responsive-lg table-responsive-sl table-responsive-xxl">
                        <table class="table table-success table-hover table-bordered">
                            <thead>
                                <tr>
                                <th>#</th>
                                <th>Group Code & Name</th>
                                <th>Item Code & Name</th>
                                <th>Issue Qty</th>
                                <th>Unit</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                    itemData && itemData.length>0 && itemData.map((data,i)=>
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td align="left">{data.groupCode}:{data.groupName}</td>
                                        <td align="left">{data.itemCode}:{data.itemName}</td>
                                        <td align="left">{data.issueQty}</td>
                                        <td align="left">{data.uom}</td>
                                    </tr>
                                    )} 
                            </tbody>
                        </table>
                        </div>
                    </div>
        </div>

    </>
    )
}

export default FirstMovingItemsCom;